import {gql} from "@apollo/client";

export const NEW_RUN_FROM_EXISTING = gql`
	mutation newRunFromExisting ($jobRunId: Int!, $graphQlQuery: String!) {
		newRunFromExisting(input: {jobRunId: $jobRunId, graphQlQuery: $graphQlQuery}) {
			jobRun {
			  id
			}
		   errors {
				... on ArgumentError {
					message
				}
			}
		}
	}
`;
